import Heading from '../../ui/Heading';
import AppLayout from '../../ui/AppLayout';

const Done = () => {
  return (
    <AppLayout image="where.jpg">
      <Heading className="mb-10">Done</Heading>
      <div className="flex flex-col items-center w-full">
        <h1>You are all set</h1>
      </div>
    </AppLayout>
  );
};

export default Done;
